import { render, staticRenderFns } from "./ProjectListItem.vue?vue&type=template&id=b4a5f740&scoped=true&lang=pug&"
import script from "./ProjectListItem.vue?vue&type=script&lang=js&"
export * from "./ProjectListItem.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListItem.vue?vue&type=style&index=0&id=b4a5f740&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a5f740",
  null
  
)

export default component.exports